import React from 'react';
import get from 'lodash.get';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { requestGetCustomers } from '../../store/customers/customers.actions';
import Global from '../../store/global-selectors';
import { useOnComponentMount } from '../../hooks/use-on-component-mount';

import { CustomersPage } from './customer-page';

export const CustomersPageLoader = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => get(state, 'customers.grid.isLoading', false));
  const shouldOpenCreateLabelModal = useSelector(Global.selectCustomersCreateLabelIsModalOpenStatus);

  useOnComponentMount(() => {
    dispatch(requestGetCustomers());
  });

  return <CustomersPage isLoading={isLoading} match={match} shouldOpenCreateLabelModal={shouldOpenCreateLabelModal} />;
};
